import React from 'react';
import { TOrderArray, TStoreAvailabilities, TStoreAvailability } from './types';
import { getDeliveryTime } from 'helpers/utils';

import _ from 'lodash';
import { getBucketName, getWithInByText, getDisplayLabel, getStoreTime, getTodayOrDate } from './functions';
import { HtmlTooltip } from './tooltip';
import { constructTitles } from './compactView';
import PopupView from './PopupView';
import { LocationOn, Store } from '@mui/icons-material';

type IProps = {
  avails: TStoreAvailabilities;
  orderArray?: TOrderArray;
}

type IViewProps = {
  avail: TStoreAvailability;
}

const View: React.FC<IViewProps> = (props) => {
  const { avail } = props;

  return <>
    {avail.validForMin && avail.validForMin > 0 ? <>
      <span className='single-line'>
        <span className='highlighter'>{`${avail.storeQty} `}</span>{" "}
        <span className='no-wrap'>{` Order by`} {`${getDeliveryTime(avail.validForMin)} ${getDisplayLabel(avail.deliveryDay, true)}`} {`${avail.deliveredByDesc}`}</span>
      </span>
      <span className=''>
        <div>{avail.stores.length > 1 ? <HtmlTooltip title={constructTitles(avail.stores)}>
          <div className='link'>
            {`${avail.stores[0].store} - ${avail.stores[0].address}`}
          </div>
        </HtmlTooltip> : `${avail.store} - ${avail.address}`}</div>
      </span>
    </>
      : !avail.validForMin ? <>{`${getWithInByText(avail)} ${getBucketName(avail, true)}`} <span className='highlighter'>{`${avail.storeQty}`}</span>
        {` Available`}</> :
        <>
          <span className='highlighter'>{`${avail.storeQty}`}</span>
          <span className='underline'>{`Order Now, `}</span>{`${avail.deliveredByDesc}`}
          <div>{avail.stores.length > 1 ? <HtmlTooltip title={constructTitles(avail.stores)}>
            <div className='link'>
              {`${avail.stores[0].store} - ${avail.stores[0].address}`}
            </div>
          </HtmlTooltip> : `${avail.store} - ${avail.address}`}</div>
        </>
    }
  </>
}

const AvailabilityFullView: React.FC<IProps> = (props) => {
  const { avails } = props;

  return <React.Fragment>
    {avails?.length > 0 && <div className='avails-fullview tooltip-wrapper'>
      <table>
        <tbody>
          <tr className='avail-compact-view-item'>
            <th className='cell qty'>
              Qty
            </th>
            <th className='cell'>Order by</th>
            <th className='cell'>Delivered by</th>
            <th className='cell'>
              Store Location
            </th>
          </tr>
          {avails.map((avail: TStoreAvailability) => {
            return <tr className='avail-compact-view-item'>
              <td className='highlighter cell'>{avail.storeQty}</td>
              <td className='cell'>
                {getTodayOrDate(avail)}
              </td>
              <td className='cell'>
                {avail.deliveredByDesc.replace('Delivered by', '')}
              </td>
              <td className='cell'>
                {avail.stores.length > 1 ? <HtmlTooltip title={constructTitles(avail.stores)}>
                  <div className='link'>
                    <Store color='error' fontSize='small' /> {`${avail.stores[0].store}`} - <LocationOn color='error' fontSize='small' /> {`${avail.stores[0].address}`}
                  </div>
                </HtmlTooltip> : <><Store color='error' fontSize='small' /> {`${avail.store}`} - <LocationOn color='error' fontSize='small' /> {`${avail.address}`}</>}
              </td>
            </tr>
          }
          )}
        </tbody>
      </table>
    </div>}
  </React.Fragment>
}

export default AvailabilityFullView;
